import { useTranslation } from '@/hooks/useTranslation';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card/Card';
import { Spinner } from '@/components/ui/spinner';
import type { Material } from '../type/Material';
import type { MaterialLot } from '../type/MaterialLot';

interface ProcessMaterialPrefillProps {
  material: Material | null;
  lot: MaterialLot | null;
  isoCategoryLabel: (path: string) => string;
}

export function ProcessMaterialPrefill({ material, lot, isoCategoryLabel }: ProcessMaterialPrefillProps) {
  const { t } = useTranslation();

  return (
    <Card tier="muted" padding="sm">
      <p className="eyebrow mb-2">
        {t('traceability.materialTab.prefill.header')}
      </p>
      {material ? (
        <div>
          <div className="flex flex-wrap items-center gap-1.5 mb-1">
            <span className="text-base font-semibold">{material.name}</span>
            {material.isoCategory && (
              <Badge tone="primary" size="sm">
                {isoCategoryLabel(material.isoCategory)}
              </Badge>
            )}
          </div>
          {material.designation && (
            <p className="font-mono text-xs text-muted-foreground">{material.designation}</p>
          )}
          {lot && (
            <div className="mt-3 border-t border-border/40 pt-3 space-y-1">
              <p className="text-xs text-muted-foreground">
                {t('traceability.materialTab.prefill.lot.supplier')}:{' '}
                <span className="font-medium text-foreground">{lot.supplier ?? '—'}</span>
              </p>
              <p className="text-xs text-muted-foreground">
                {t('traceability.materialTab.prefill.lot.lot')}:{' '}
                <span className="font-mono text-foreground">{lot.lotNumber ?? '—'}</span>
              </p>
            </div>
          )}
        </div>
      ) : (
        <div className="flex items-center gap-2 text-muted-foreground text-sm">
          <Spinner />
        </div>
      )}
      <p className="mt-3 text-xs text-muted-foreground/70 italic">
        {t('traceability.materialTab.prefill.locked')}
      </p>
    </Card>
  );
}
